import { createPortal } from "react-dom";

/**
 * Đưa modal / lớp phủ ra ngoài cây nội dung trang, gắn thẳng vào `.admin-root` (khung ngoài cùng của admin, không có transform).
 *
 * Lý do: `position: fixed` bị tính theo phần tử cha nếu cha có transform / filter / backdrop-filter / contain…
 * (vd thẻ đang chạy animation, header backdrop-blur) → lớp phủ không phủ hết màn hình. Portal tránh mọi trường hợp đó.
 * Gắn vào `.admin-root` (không phải body) để vẫn nhận font, màu và các style `.admin-root …` của admin.
 */
export default function AdminPortal({ children }) {
  if (typeof document === "undefined") return children;
  const target = document.querySelector(".admin-root") || document.body;
  return createPortal(children, target);
}
